<template>
  <div class="show-component" v-if="!isMobile">
      <v-expand-transition v-model="hide"  @click="getVersion">
          <div v-if="hide">
              <div class="show-button">
                  <img :src="require('@/assets/icon/eye-version.svg')" alt="" style="padding-right: 4px">
                  <span>Версия для слабовидящих</span>
                  <img :src="require('@/assets/icon/error-right.svg')" alt="">
              </div>
          </div>
      </v-expand-transition>
      <v-expand-transition v-model="show">
          <div v-if="show" style="border-bottom: black 1px solid" class=" back-black">
              <div class="blocks">
                  <div class="block">
                      <span style="font-family: my-inter-bold,serif">Размер шрифта</span>
                      <div style="display: flex; flex-direction: row; gap: 16px; align-items: baseline">
                          <div class="button" @click="setSize('-')" style="background: white; color: black">A-</div>
                          <div class="button" @click="setSize('+')" style="background: white; color: black">A+</div>
                      </div>
                  </div>
                  <div class="block">
                      <span style="font-family: my-inter-bold,serif">Цвет сайта</span>
                      <div style="display: flex; flex-direction: row; gap: 8px;">
                          <div class="button" @click="setTheme('black-theme')" style="color: white; background: black;">A</div>
                          <div class="button" @click="setTheme('white-theme')" style="background: white!important; color: black!important;">A</div>
                      </div>
                  </div>
                  <div class="block">
                      <span style="font-family: my-inter-bold,serif">Изображения</span>
                      <div @click="toggleImagesForAccessibility(null)" class="button" style="width: max-content; padding: 4px">
                          <v-icon>{{imagesDisabled ? 'mdi-eye' : 'mdi-eye-off'}}</v-icon>
                      </div>
                  </div>
                  <div @click="clear" class="button" style="background: white; color: black; align-self: end">Обычная версия сайта</div>
              </div>
          </div>
      </v-expand-transition>
  </div>
</template>

<script setup>
import {onMounted, ref, onUnmounted} from "vue";
import {useCounterStore} from "@/store";
const fontStore = useCounterStore();
const isMobile = ref(window.innerWidth <= 500);

let show = ref(false);
let imagesDisabled = ref(fontStore.img);
let hide = ref(true);
let currSize = ref(fontStore.fontSize);

function getVersion () {
    localStorage.setItem('version', true);
    show.value = !show.value;
    hide.value = !hide.value;
}
function checkIsMobile() {
    isMobile.value = window.innerWidth <= 500;
}
function setTheme (t) {
    fontStore.setMainStyle(t ?? 'default-theme');
    localStorage.setItem('style', t ?? 'default-theme');
}
function toggleImagesForAccessibility(item) {
    if (item !== null) imagesDisabled.value = item;
    else imagesDisabled.value = !imagesDisabled.value;
    if (imagesDisabled.value) {
        document.body.classList.add('no-images');
    } else {
        document.body.classList.remove('no-images');
    }
}
function setSize (val) {
    switch (val){
        case '-':
            if (currSize.value !== 16) {
                currSize.value = currSize.value - 4;
                fontStore.setFontSize(currSize.value);
                localStorage.setItem('size', currSize.value);
            }
            break;
        case '+':
            if (currSize.value !== 32) {
                currSize.value = currSize.value + 4;
                fontStore.setFontSize(currSize.value);
                localStorage.setItem('size', currSize.value);
            }
            break;
        default:
            currSize.value = 16;
            fontStore.setFontSize(currSize.value);
            localStorage.setItem('size', currSize.value);

    }
}
function clear () {
    setSize('');
    setTheme(null);
    localStorage.setItem('version', false);
    show.value = !show.value;
    hide.value = !hide.value;
    toggleImagesForAccessibility(false);
}
onMounted(() => {
    window.addEventListener('resize', checkIsMobile);
    let currSize = localStorage.getItem('size');
    if (!currSize) setSize(null);
    if (fontStore.version) {
        hide.value = false;
        show.value = true;
    } else {
        hide.value = true;
        show.value = false;
    }
    toggleImagesForAccessibility(imagesDisabled.value);
});
onUnmounted(() => {
    window.removeEventListener('resize', checkIsMobile);
});
</script>
